export const buildVersion = '199n'
export const appVersion = '1.0.19d'
